import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KPI } from "@/components/Primitives";

export default function Leakage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/leakage/overview").then(r => setD(r.data)); }, []);
  if (!d) return <div className="text-zinc-500 text-sm">Loading…</div>;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Revenue Leakage Intelligence</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Estimated Cost Leakage</h1>
        <p className="text-sm text-zinc-500 mt-1">Quantified waste from open tickets, recurring issues, escalations and failed backups.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI label="Monthly Waste" value={`₱${d.monthly_waste_php.toLocaleString()}`} tone="bad" testid="leak-month"/>
        <KPI label="Quarterly Waste" value={`₱${d.quarterly_waste_php.toLocaleString()}`} tone="warn" testid="leak-quarter"/>
        <KPI label="Annual Waste" value={`₱${d.annual_waste_php.toLocaleString()}`} tone="bad" testid="leak-annual"/>
        <KPI label="Recurring Cost" value={`₱${d.totals.recurring_cost.toLocaleString()}`} testid="leak-recurring"/>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Top title="Top Cost Clients" items={d.top_clients} keyFn={x=>x.client_id} val={x=>`₱${x.cost.toLocaleString()}`} testid="leak-top-clients"/>
        <Top title="Top Cost Assets" items={d.top_assets} keyFn={x=>x.asset_id} val={x=>`₱${x.cost.toLocaleString()}`} testid="leak-top-assets"/>
        <Top title="Top Cost Categories" items={d.top_categories} keyFn={x=>x.category} val={x=>`₱${x.cost.toLocaleString()}`} testid="leak-top-categories"/>
      </div>
    </div>
  );
}

function Top({ title, items, keyFn, val, testid }) {
  return (
    <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5" data-testid={testid}>
      <div className="font-display font-medium mb-3">{title}</div>
      <div className="space-y-1.5">
        {items.map((it, i) => (
          <div key={i} className="flex justify-between text-xs border-b border-zinc-900 pb-1.5">
            <div className="font-mono text-zinc-300 truncate max-w-[60%]">{keyFn(it)}</div>
            <div className="font-mono text-emerald-400">{val(it)}</div>
          </div>
        ))}
        {items.length === 0 && <div className="text-xs text-zinc-500">No data yet.</div>}
      </div>
    </div>
  );
}
